import { render, staticRenderFns } from "./JdsTableBadge.vue?vue&type=template&id=2d8c0fc9&scoped=true&"
import script from "./JdsTableBadge.vue?vue&type=script&lang=ts&"
export * from "./JdsTableBadge.vue?vue&type=script&lang=ts&"
import style0 from "./JdsTableBadge.vue?vue&type=style&index=0&id=2d8c0fc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c0fc9",
  null
  
)

export default component.exports